<ui-modal
  [isOpened]="true"
  modalTitle="Multi Leg Solver"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="multi-leg-solver">
    <form
      [formGroup]="solverForm"
      [inert]="currentlySolving"
      autocomplete="off"
    >
      <div class="solver-row">
        <div class="clr-form-control">
          <label class="clr-control-label">For</label>
          <div class="selector-container-for small-top-padding">
            <app-selector
              class="selector"
              [formControlName]="'targetField'"
              [passedItems]="['Delta Neutral', 'Vega Neutral']"
              [isSearch]="false"
            ></app-selector>
          </div>
        </div>
      </div>
      <div class="solver-row">
        <div class="clr-form-control">
          <label class="clr-control-label">By Changing</label>
          <div class="selector-container-for small-top-padding">
            <app-selector
              class="selector"
              [formControlName]="'inputField'"
              [passedItems]="inputFields"
              [isSearch]="false"
              required
            ></app-selector>
          </div>
        </div>
        <div class="clr-form-control">
          <label class="clr-control-label">Use Leg</label>
          <div class="selector-container-leg-number small-top-padding">
            <app-selector
              class="selector"
              [formControlName]="'inputLegNumber'"
              [passedItems]="legsNumbered"
              [isSearch]="false"
              required
            ></app-selector>
          </div>
        </div>

        <div class="clr-form-control">
          <label class="clr-control-label">Solved</label>
          <input
            type="number"
            class="clr-input small-top-padding"
            [formControlName]="'solvedValue'"
          />
        </div>
      </div>
    </form>
    <hr class="hard-return" />
    <div class="multi-leg-solver__footer">
      <button
        type="submit"
        class="ui-button primary multi-leg-solver__footer__button"
        (click)="onSolverSubmit()"
        [disabled]="!solverForm.valid || currentlySolving"
      >
        <div
          class="multi-leg-solver__footer__button__spinner-container"
          *ngIf="currentlySolving; else allowPricing"
        >
          <span class="spinner spinner-sm spinner-inverse"> </span>
        </div>

        <ng-template #allowPricing> Solve </ng-template>
      </button>

      <div class="multi-leg-solver__footer__apply-section">
        <span>Apply To Leg:</span>
        <div class="clr-form-control">
          <div class="selector-container-leg-number">
            <app-selector
              class="selector"
              [passedItems]="legsNumbered"
              [isSearch]="false"
              (valueEmitter)="changeInLegToApplyTo($event.value)"
            ></app-selector>
          </div>
        </div>
        <button
          type="button"
          class="ui-button primary"
          [disabled]="legToApplyTo == null"
          (click)="applySolvedValue()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</ui-modal>
